/**
 * Derives a CryptoKey from a string passphrase using SHA-256
 */

const encryptionKey = import.meta.env.VITE_ENCRYPTION_KEY || '';

const getCryptoKey = async () => {
  const encoder = new TextEncoder();
  const keyBuffer = encoder.encode(encryptionKey);
  const hash = await crypto.subtle.digest('SHA-256', keyBuffer);
  return crypto.subtle.importKey('raw', hash, { name: 'AES-GCM' }, false, [
    'encrypt',
  ]);
};

/**
 * Encrypts a string using AES-GCM and returns a base64 string
 */
export const encryptString = async (data: string): Promise<string> => {
  const cryptoKey = await getCryptoKey();
  const iv = crypto.getRandomValues(new Uint8Array(12)); // AES-GCM standard IV length

  const encoded = new TextEncoder().encode(data);
  const encrypted = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    encoded
  );

  const combined = new Uint8Array(iv.length + encrypted.byteLength);
  combined.set(iv);
  combined.set(new Uint8Array(encrypted), iv.length);

  // Convert to base64
  return btoa(String.fromCharCode(...combined));
};

// // utils/decryptor.ts (Node.js backend)

// import crypto from 'crypto';

// /**
//  * Decrypts an AES-GCM encrypted base64 string.
//  * @param encryptedBase64 - The encrypted string (IV + ciphertext) in base64
//  * @param secretKey - Your encryption key (same as frontend)
//  */
// export const decryptString = (encryptedBase64: string, secretKey: string): string => {
//   const encryptedData = Buffer.from(encryptedBase64, 'base64');

//   const iv = encryptedData.subarray(0, 12); // First 12 bytes are the IV
//   const ciphertext = encryptedData.subarray(12);

//   // Create a 256-bit (32-byte) key using SHA-256 hash of the secretKey
//   const key = crypto.createHash('sha256').update(secretKey).digest();

//   const decipher = crypto.createDecipheriv('aes-256-gcm', key, iv);

//   // If authentication tag is used, extract it from the end
//   // But since Web Crypto returns ciphertext + tag together, no separate tag here
//   decipher.setAuthTag(ciphertext.subarray(ciphertext.length - 16));
//   const dataWithoutTag = ciphertext.subarray(0, ciphertext.length - 16);

//   let decrypted = decipher.update(dataWithoutTag);
//   decrypted = Buffer.concat([decrypted, decipher.final()]);

//   return decrypted.toString('utf-8');
// };
